/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Downpayment/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import BankAccount from './BankAccount/index'
import CreditCard from './CreditCard/index'
import InOffice from './InOffice/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Downpayment({
  children,
  viewPath = "/App/Account/EmbeddableCoreMessageListener/TreatmentRequestOverride/Content/Downpayment"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Downpayment.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-ZM8Ln2': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-2-ZM8Ln2': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-ZM8Ln2': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-4-ZM8Ln2': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 text="Down Payment"
/>
<InOffice
  viewPath={`${viewPath}/InOffice`}
/>
<BankAccount
  viewPath={`${viewPath}/BankAccount`}
/>
<CreditCard
  viewPath={`${viewPath}/CreditCard`}
/>
</div>
{children}
</React.Fragment>)
}